import "./modules/atc";

/* exported owlNavigation */
function owlNavigation(slider) {
    $(`#${slider} .owl-prev`).hide();
    $(`#${slider}`).on("translated.owl.carousel", function() {
        if ($(`#${slider} .owl-item:first-child`).hasClass("active")) {
            $(`#${slider} .owl-prev`).hide();
        } else {
            $(`#${slider} .owl-prev`).show();
        }

        if ($(`#${slider} .owl-item:last-child`).hasClass("active")) {
            $(`#${slider} .owl-next`).hide();
        } else {
            $(`#${slider} .owl-next`).show();
        }
    });
}

function setFooterFixed() {
    const primaryFooterHeight = $(".footer").outerHeight();
    const navHeight = $(".header").outerHeight();
    const body = $("#page").innerHeight();
    const contentHeight = navHeight + body;
    // Need to take into account the footer height because pages that are just barely short enough will be covered by the fixed footer.
    const windowHeight = $(window).height() - primaryFooterHeight;

    $(".footer").removeAttr("style");
    if (contentHeight < windowHeight) {
        // Make footer fixed to bottom if body content isn't tall enough
        $(".footer").css({ bottom: "0", position: "fixed" });
    }
}

function bootstrapify(elements, bClass) {
    for (let i = 0; i < elements.length; i++) {
        elements[i].classList.add(bClass);
    }
}

$(function() {
    setFooterFixed();
    owlNavigation("postsslider");

    const doesCss = "CSS" in window;

    if (!doesCss || !CSS.supports("display", "grid")) {
        const postsSections = document.querySelectorAll(".all-posts-section");
        const others = document.querySelectorAll(".others");
        const $set = $(".alm-paging-content").children();
        for (let i = 0, len = $set.length; i < len; i += 2) {
            $set.slice(i, i + 2).wrapAll("<div class='row'/>");
        }

        bootstrapify(postsSections, "col-xs-6");
        bootstrapify(others, "col-md-9");
    }

    if (!window.matchMedia("(max-width: 1023px)").matches) {
        if ($(".first-row").length > 0) {
            const firstHeight = $(".first-row").height();
            $(".first-row .card-wrap").css("min-height", firstHeight);
        }

        if ($(".second-row").length > 0) {
            const secondHeight = $(".second-row").height();
            $(".second-row .card-wrap").css("min-height", secondHeight);
        }
    }

    /* Back to Top Button*/

    const amountScrolled = 300;

    $(window).scroll(function() {
        if ($(window).scrollTop() > amountScrolled) {
            $("button.back-to-top").addClass("scaled");
        } else {
            $("button.back-to-top").removeClass("scaled");
        }
    });

    $("button.back-to-top").click(function() {
        $("html, body").animate(
            {
                scrollTop: 0,
            },
            500
        );
        return false;
    });

    $("#category-button").click(function() {
        $(".site-header-menu").toggleClass("show-categories");
    });
});
